<template>
  <div class="wrap" style="padding:10px">
    <keep-alive>
      <router-view :level1="level1" :level2="level2"></router-view>
    </keep-alive>
    <Modal
        title="会话超时"
        width="300"
        v-model="loginStatus"
        :mask-closable="false"
        :closable="false">
      <div v-if="!loginErrorMsg || loginErrorMsg.includes('token')">
        <p>无法验证身份，您的会话已超时！</p>
        <p>请重新登录。</p>
      </div>
      <p v-else>{{loginErrorMsg}}</p>
      <div slot="footer">
        <Button type="primary" size="large" @click="redirectLogin">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    level1: '',
    level2: ''
  },
  data () {
    return {}
  },
  created () {
  },
  computed: {
    loginStatus () {
      return !this.$store.state.loginStatus;
    },
    loginErrorMsg () {
      return this.$store.state.loginErrorMsg;
    }
  },
  methods: {
    redirectLogin () {
      this.$router.push({path: '/login', query: { redirect: this.$route.path }});
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/home/homeRouter.vue